import { render, staticRenderFns } from "./AddStock.vue?vue&type=template&id=445bbe70&scoped=true"
import script from "./AddStock.vue?vue&type=script&lang=js"
export * from "./AddStock.vue?vue&type=script&lang=js"
import style0 from "./AddStock.vue?vue&type=style&index=0&id=445bbe70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445bbe70",
  null
  
)

export default component.exports